var GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_VERSION, GoogleMaps, MAP_PROXY_CHANNEL, MAP_PROXY_HOST_EU, MAP_PROXY_HOST_NA, callbacks, getMapProxyHost, loaded, loading;

MAP_PROXY_CHANNEL = 'layout-service';

MAP_PROXY_HOST_NA = '//mapproxy.groupon.com';

MAP_PROXY_HOST_EU = '//mapproxy-eu.groupon.com';

GOOGLE_MAPS_VERSION = 3;

GOOGLE_MAPS_LIBRARIES = ['geometry'];

loading = false;

callbacks = [];

loaded = function() {
  var cb, i, len, results;
  results = [];
  for (i = 0, len = callbacks.length; i < len; i++) {
    cb = callbacks[i];
    results.push(cb());
  }
  return results;
};

getMapProxyHost = function() {
  var country;
  country = document.head.getAttribute('data-country');
  if (country === 'US' || country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
    return MAP_PROXY_HOST_NA;
  } else {
    return MAP_PROXY_HOST_EU;
  }
};

module.exports = GoogleMaps = {
  load: function(cb) {
    var callbackName, query, ref;
    if (cb == null) {
      cb = function() {};
    }
    if (((ref = window.google) != null ? ref.maps : void 0) != null) {
      return cb();
    }
    callbacks.push(cb);
    if (loading) {
      return;
    }
    loading = true;
    callbackName = 'layoutServiceGoogleMapsCallback';
    window[callbackName] = loaded;
    query = $.param({
      sensor: false,
      v: GOOGLE_MAPS_VERSION,
      libraries: GOOGLE_MAPS_LIBRARIES.join(','),
      callback: callbackName,
      region: document.head.getAttribute('data-country') || 'US',
      language: document.head.getAttribute('data-language') || 'en-US',
      channel: MAP_PROXY_CHANNEL
    });
    return $.getScript((getMapProxyHost()) + "/maps/api/js?" + query).fail(function() {
      return cb(new Error('Unable to load Google Maps Library'));
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvbW9kdWxlcy9nb29nbGVfbWFwcy9mcm9udGVuZC9nb29nbGVfbWFwcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9tb2R1bGVzL2dvb2dsZV9tYXBzL2Zyb250ZW5kL2dvb2dsZV9tYXBzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxJQUFBOztBQUFBLGlCQUFBLEdBQW9COztBQUNwQixpQkFBQSxHQUFvQjs7QUFDcEIsaUJBQUEsR0FBb0I7O0FBRXBCLG1CQUFBLEdBQXNCOztBQUN0QixxQkFBQSxHQUF3QixDQUFDLFVBQUQ7O0FBRXhCLE9BQUEsR0FBVTs7QUFDVixTQUFBLEdBQVk7O0FBRVosTUFBQSxHQUFTLFNBQUE7QUFDUCxNQUFBO0FBQUE7T0FBQSwyQ0FBQTs7aUJBQUEsRUFBQSxDQUFBO0FBQUE7O0FBRE87O0FBR1QsZUFBQSxHQUFrQixTQUFBO0FBQ2hCLE1BQUE7RUFBQSxPQUFBLEdBQVUsUUFBUSxDQUFDLElBQUksQ0FBQyxZQUFkLENBQTJCLGNBQTNCO0VBR1YsSUFBRyxPQUFBLEtBQVksSUFBWixJQUFBLE9BQUEsS0FBa0IsSUFBbEIsSUFBQSxPQUFBLEtBQXdCLElBQXhCLElBQUEsT0FBQSxLQUE4QixJQUE5QixJQUFBLE9BQUEsS0FBb0MsSUFBcEMsSUFBQSxPQUFBLEtBQTBDLElBQTFDLElBQUEsT0FBQSxLQUFnRCxJQUFoRCxJQUFBLE9BQUEsS0FBc0QsSUFBekQ7V0FDRSxrQkFERjtHQUFBLE1BQUE7V0FHRSxrQkFIRjs7QUFKZ0I7O0FBU2xCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFVBQUEsR0FFZjtFQUFBLElBQUEsRUFBTSxTQUFDLEVBQUQ7QUFDSixRQUFBOztNQUFBLEtBQU0sU0FBQSxHQUFBOztJQUNOLElBQWUsMkRBQWY7QUFBQSxhQUFPLEVBQUEsQ0FBQSxFQUFQOztJQUNBLFNBQVMsQ0FBQyxJQUFWLENBQWUsRUFBZjtJQUVBLElBQVUsT0FBVjtBQUFBLGFBQUE7O0lBQ0EsT0FBQSxHQUFVO0lBRVYsWUFBQSxHQUFlO0lBQ2YsTUFBTyxDQUFBLFlBQUEsQ0FBUCxHQUF1QjtJQUV2QixLQUFBLEdBQVEsQ0FBQyxDQUFDLEtBQUYsQ0FDTjtNQUFBLE1BQUEsRUFBUSxLQUFSO01BQ0EsQ0FBQSxFQUFHLG1CQURIO01BRUEsU0FBQSxFQUFXLHFCQUFxQixDQUFDLElBQXRCLENBQTJCLEdBQTNCLENBRlg7TUFHQSxRQUFBLEVBQVUsWUFIVjtNQUlBLE1BQUEsRUFBUSxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQWQsQ0FBMkIsY0FBM0IsQ0FBQSxJQUE4QyxJQUp0RDtNQUtBLFFBQUEsRUFBVSxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQWQsQ0FBMkIsZUFBM0IsQ0FBQSxJQUErQyxPQUx6RDtNQU1BLE9BQUEsRUFBUyxpQkFOVDtLQURNO1dBU1IsQ0FBQyxDQUFDLFNBQUYsQ0FBYyxDQUFDLGVBQUEsQ0FBQSxDQUFELENBQUEsR0FBbUIsZUFBbkIsR0FBa0MsS0FBaEQsQ0FBd0QsQ0FBQyxJQUF6RCxDQUE4RCxTQUFBO2FBQzVELEVBQUEsQ0FBTyxJQUFBLEtBQUEsQ0FBTSxvQ0FBTixDQUFQO0lBRDRELENBQTlEO0VBcEJJLENBQU4ifQ==
